import { FC, useRef } from 'react';
import { RouteComponentProps, Switch, Redirect } from 'react-router-dom';
import PruRoute from 'src/app/common/components/PruRoute';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { GAData } from 'src/app/common/ga/redux/gaSlice';
import { CAMPAIGN_BASE_PATH, SERVICING_CAMPAIGN_DETAIL_PATH, SERVICING_CAMPAIGN_LIST_PATH } from '../../constants';
import { DetailPagePage } from './Detail/detail-page.screen';
import { ListPage } from './List/list.screen';

const servicingCampaignDetailGaDataRoute: GAData = {
  module: 'PRULeads',
  feature: 'Campaign',
  journey: 'View Servicing Campaign',
  stage: 'View Servicing Campaign Detail',
  screen_name: 'Servicing Campaign Detail',
};

const campaignListGaDataRoute21: GAData = {
  module: 'PRULeads',
  feature: 'Campaign',
  journey: 'View Servicing Campaign',
  stage: 'View Campaign List',
  screen_name: 'Campaign List',
};

export const SERVICING_LIST_PATH = `${CAMPAIGN_BASE_PATH}${SERVICING_CAMPAIGN_LIST_PATH}`;
export const SERVICING_DETAIL_PATH = `${CAMPAIGN_BASE_PATH}${SERVICING_CAMPAIGN_LIST_PATH}${SERVICING_CAMPAIGN_DETAIL_PATH}`;

const ServicingCampaignRoutes: FC<RouteComponentProps> = (props) => {
  return (
    <Switch>
      <PruRoute
        exact
        gaData={servicingCampaignDetailGaDataRoute}
        path={`${SERVICING_DETAIL_PATH}/:id`}
        render={(props) => <DetailPagePage {...props} />}
      />
      <PruRoute
        exact
        gaData={campaignListGaDataRoute21}
        path={SERVICING_LIST_PATH}
        render={(props) => <ListPage {...props} />}
      />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default ServicingCampaignRoutes;
